module.exports = __webpack_public_path__ + "img/mn.9d8fd41f.svg";